$ = jQuery;

function accordion() {
  $(window).on('load', function() {
    if ($('.accordion-tab-title').length) {
      $('.accordion-tab-title').click(function() {
        var currentTab = $(this);

        currentTab.
          closest('.paragraph--type--accordion-tab').closest('.field__item').
          siblings().
          find('.accordion-tab-title').
          removeClass('active').
          next('.accordion-tab-content').
          removeClass('overflow-visible').
          css('max-height', 0);

        currentTab.
          toggleClass('active').
          next('.accordion-tab-content').
          addClass('overflow-visible').
          css('max-height',
            currentTab.next('.accordion-tab-content')[0].scrollHeight + 'px');

        if (!currentTab.hasClass('active')) {
          currentTab.
            next('.accordion-tab-content').
            removeClass('overflow-visible').
            css('max-height', 0);
        }


        if (currentTab.hasClass('active')) {
          setTimeout(function() {
            $('html, body').animate({
              scrollTop: currentTab.offset().top - $('.header-topbar-main-container').height(),
            }, 500);
          }, 450);
        }
      });
    }
  });

  var spans = document.querySelectorAll(
    '.paragraph--type--text span, .paragraph--type--basic-text span');

  if (spans.length) {
    Array.prototype.forEach.call(spans, function(span) {
      if (span.style.color) {
        span.classList.add('white-space');
      }
    });
  }
}
